import React from 'react';

import { InputText } from "primereact/inputtext";
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Steps } from 'primereact/steps';
import { InputNumber } from 'primereact/inputnumber';
import { InputMask } from "primereact/inputmask";
import { hideProcess, showProcess } from '../utils/utils';
import ClienteService from '../services/ClienteService';

import CryptoJS from 'crypto-js';

class PreCadastro extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 0,
            cliente: {},
            validacaoTelefone: "pending"
        }
    }

    componentDidMount(){    
    
    }

    items = [
        {
            label: 'Dados Pessoais'
        },
        {
            label: 'Endereço'
        },
        {
            label: 'Segurança'
        },
        {
            label: 'Finalização'
        }
    ];

    validarCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, '');
        if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) {
            soma += parseInt(cpf.charAt(i)) * (10 - i);
        }
        let resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(9))) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) {
            soma += parseInt(cpf.charAt(i)) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        return resto === parseInt(cpf.charAt(10));
    }

    validarCNPJ(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, '');
        if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) return false;

        tamanho++;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        return resultado === parseInt(digitos.charAt(1));   
    }   

    validarDocumento(valor) {
        const doc = valor.replace(/[^\d]+/g, '');
        if (doc.length === 11) {
            return this.validarCPF(doc);
        } else if (doc.length === 14) {
            return this.validarCNPJ(doc);
        } else {
            return false;
        }
    }

    confirmarStep0 = (e) => {

        e.preventDefault()

        if (this.state.validacaoTelefone === 'sucess' && this.state.validacaoCPF === 'sucess')

        if (!this.validarDocumento(this.state.cliente.cpf)){
            alert("CPF OU CNPJ INVÁLIDO.");
            return;
        }

        this.setState({step: 1})

    }

    buscarEndereco = async () => {
        try{
            await showProcess();

            let cep = this.state.cliente.cep.replace("-", "").replace(".", "")
            if (cep.length !== 8) {
                alert("CEP inválido. Deve conter 8 dígitos.");
                return;
            }

            var that = this

            var response = fetch(`https://viacep.com.br/ws/${cep}/json/`)
                .then(response => response.json())
                .then(data => {

                    const uf = data.uf !== undefined && data.uf !== null ? data.uf.toUpperCase() : data.uf;
                    const bairro = data.bairro !== undefined && data.bairro !== null ? data.bairro.toUpperCase() : data.bairro;
                    const localidade = data.localidade !== undefined && data.localidade !== null ? data.localidade.toUpperCase() : data.localidade;
                    const logradouro = data.logradouro !== undefined && data.logradouro !== null ? data.logradouro.toUpperCase() : data.logradouro;

                    that.setState(prevState  => ({cliente:{...prevState.cliente, uf: uf, bairro: bairro, cidade: localidade, logradouro: logradouro}}));

                    hideProcess();
                }
                )
                .catch(error => {
                    alert("Erro ao buscar CEP:", error);
                    hideProcess();
                });
        }catch(e){
            hideProcess();
        }
        
    }

    confirmarSenha = (e) => {

        e.preventDefault();

        if (this.state.cliente.senha !== this.state.confirmacaoSenha){
            alert('Senhas diferentes, favor corrigir.');
            return;
        }

        this.setState({step: 3});
    }

    validarTelefone = async (e) => {
        if (this.state.validacaoTelefone === 'pending'){
            try{
                await showProcess();

                const response = await ClienteService.getByTelefone(this.state.cliente.telefone);

                if (response.data.status === "sucess"){

                    if (response.data.object.length > 0){
                        
                        this.setState({validacaoTelefone: 'error'});
                        
                        alert("Já existe um cliente cadastrado com este número de telefone.");

                    }else{
                        this.setState({validacaoTelefone: 'sucess'});
                    }

                }else{

                    this.setState({validacaoTelefone: 'error'});

                    alert(response.data.message);

                }

            }catch(e){
                hideProcess();
            }

            hideProcess();
        }
    }

    validarCpf = async (e) => {
        if (this.state.validacaoCPF === 'pending'){
            try{
                await showProcess();

                const response = await ClienteService.getByCpf(this.state.cliente.cpf);

                if (response.data.status === "sucess"){

                    if (response.data.object.length > 0){
                        
                        this.setState({validacaoCPF: 'error'});
                        
                        alert("Já existe um cliente com este CPF/CNPJ.");

                    }else{
                        this.setState({validacaoCPF: 'sucess'});
                    }

                }else{

                    this.setState({validacaoCPF: 'error'});

                    alert(response.data.message);

                }

            }catch(e){
                hideProcess();
            }

            hideProcess();
        }
    }

    confirmarCadastro = async (e) => {

        e.preventDefault();

        if (this.state.confirmacaoCliente){
            try{
                await showProcess();

                var cliente = {...this.state.cliente};

                const { v4: uuidv4 } = require('uuid');
                
                const id = uuidv4();

                cliente['id'] = id;

                cliente.senha = CryptoJS.MD5(cliente.senha).toString()

                const response = await ClienteService.create(cliente);

                if (response.data.status === "sucess"){

                    window.location.href = "/confirmacaocadastro";

                }else{

                    alert(response.data.message);

                }

            }catch(e){
                hideProcess();
            }

            hideProcess();
        }
    }


    render() {
      return(
          <div className='app-pre-cadastro'>
                <div>
                    <div style={{background: 'none', boxShadow: 'none'}}>
                            <Steps model={this.items} activeIndex={this.state.step} />
                    </div>   
                    <div className='app-pre-cadastro-quadro'>
                        <div className="flex align-items-center">
                            <img src={require("../img/coroa.webp")} style={{width: '40px'}} />
                            <span style={{marginLeft: '10px'}} />
                            <span style={{fontSize: '30px'}} className='app-titulo'>VILLA OURO</span>
                        </div>

                        
                            

                        {this.state.step === 0 &&
                            <form onSubmit={(e) => this.confirmarStep0(e)}>
                                <div style={{textAlign: 'center', marginTop: '20px', marginBottom: '2px'}}>
                                    
                                </div>
                                <div>
                                    Nome Estabelecimento
                                    <InputText required placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.nome} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, nome: e.target.value.toLocaleUpperCase()}}))} />
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    Telefone
                                    <InputText required className={this.state.validacaoTelefone === 'error' ? 'app-input-error' : ''} keyfilter="int" maxLength={11} placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.telefone} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, telefone: e.target.value}, validacaoTelefone: 'pending'}))} onBlur={() => this.validarTelefone()}/>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    CPF ou CNPJ
                                    <InputText required className={this.state.validacaoCPF === 'error' ? 'app-input-error' : ''} keyfilter="int" maxLength={14} placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.cpf} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, cpf: e.target.value}, validacaoCPF: 'pending'}))}  onBlur={() => this.validarCpf()}/>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    Email
                                    <InputText placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.email} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, email: e.target.value}}))}/>
                                </div> 
                                <div style={{marginTop: '20px', height: '38px'}}>
                                    <Button label="AVANÇAR" type='submit' className='app-background-gold' style={{float: 'right'}} />
                                </div>
                            </form>
                        }

                        {this.state.step === 1 &&
                            <form onSubmit={(e) => {e.preventDefault() ;this.setState({step: 2})}}>
                                <div style={{textAlign: 'center', marginTop: '20px', marginBottom: '2px'}}>
                                    
                                </div>
                                <div>
                                    CEP
                                    <InputMask mask="99-999.999" required placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.cep} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, cep: e.target.value.toUpperCase()}}))} onBlur={() => this.buscarEndereco()}/>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    UF
                                    <InputText required placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.uf} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, uf: e.target.value.toUpperCase()}}))}/>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    CIDADE
                                    <InputText required placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.cidade} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, cidade: e.target.value.toUpperCase()}}))}/>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    BAIRRO
                                    <InputText required placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.bairro} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, bairro: e.target.value.toUpperCase()}}))}/>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    RUA
                                    <InputText required placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.logradouro} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, logradouro: e.target.value.toUpperCase()}}))}/>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    NÚMERO
                                    <InputText required placeholder='' style={{minWidth: '100%'}} value={this.state.cliente.numero} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, numero: e.target.value.toUpperCase()}}))}/>
                                </div>
                                    
                                <div style={{marginTop: '20px', height: '38px'}}>
                                    <Button label="AVANÇAR" type='submit' className='app-background-gold' style={{float: 'right'}} />
                                    <Button label="VOLTAR"  className='app-background-gold' style={{float: 'right', marginRight: '10px'}} formNoValidate onClick={() => this.setState({step: 0})}/>
                                </div>
                            </form>
                        }
                        {this.state.step === 2 &&
                            <form onSubmit={(e) => this.confirmarSenha(e)}>
                                <div style={{textAlign: 'center', width: '100%', marginTop: '20px', marginBottom: '20px'}}>
                                    Sua senha deve possuir no mínimo 6 dígitos, ela será utilizada para entrar na aplicação.
                                </div>
                                <div>
                                    SENHA
                                    <Password feedback={false} minLength={6} required style={{minWidth: '100%'}} inputStyle={{minWidth: '100%'}} value={this.state.cliente.senha} onChange={(e) => this.setState(prevState  => ({cliente:{...prevState.cliente, senha: e.target.value}}))} onBlur={() => this.buscarEndereco()}/>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    REPETIR
                                    <Password feedback={false}  required placeholder='' style={{minWidth: '100%'}} inputStyle={{minWidth: '100%'}} value={this.state.confirmacaoSenha} onChange={(e) => this.setState({confirmacaoSenha: e.target.value})}/>
                                </div>
                                    
                                <div style={{marginTop: '20px', height: '38px'}}>
                                    <Button label="AVANÇAR" type='submit' className='app-background-gold' style={{float: 'right'}} />
                                    <Button label="VOLTAR"  className='app-background-gold' style={{float: 'right', marginRight: '10px'}} formNoValidate onClick={() => this.setState({step: 1})}/>
                                </div>
                            </form>
                        }

                        {this.state.step === 3 &&
                            <form onSubmit={(e) => this.confirmarCadastro(e)}>
                                <div style={{textAlign: 'center', marginTop: '20px', marginBottom: '2px'}}>
                                    <h1>
                                        Termo de Confirmação e Responsabilidade sobre os Dados Cadastrais
                                    </h1>
                                </div>
                                
                                <div>
                                    <p>
                                        &nbsp; &nbsp; Declaro, para os devidos fins, que sou o legítimo titular das informações pessoais e cadastrais fornecidas neste formulário.
                                    </p>
                                    <p>
                                        &nbsp; &nbsp; Confirmo que todos os dados informados são verdadeiros, precisos e atualizados, sendo de minha total responsabilidade quaisquer informações incorretas, incompletas ou falsas.
                                    </p>
                                    <p>
                                        &nbsp; &nbsp; Estou ciente de que o uso indevido de dados de terceiros sem autorização pode implicar em sanções legais, conforme a legislação vigente, inclusive a Lei Geral de Proteção de Dados Pessoais (LGPD – Lei nº 13.709/2018).
                                    </p>
                                    <p>
                                        &nbsp; &nbsp; Autorizo o tratamento dos meus dados pessoais para fins de cadastro, contato e cumprimento de obrigações legais e contratuais, nos termos da política de privacidade da empresa.
                                    </p>
                                </div>

                                <div className="flex align-items-center" style={{marginTop: '20px'}}>
                                    <Checkbox inputId='ckAceite' required onChange={e => this.setState({confirmacaoCliente: e.checked})} checked={this.state.confirmacaoCliente}></Checkbox>
                                    <label htmlFor="ckAceite" className="ml-2">Aceito o termo acima</label>
                                </div>
                                
                                    
                                <div style={{marginTop: '20px', height: '38px'}}>
                                    <Button label="FINALIZAR" type='submit' className='app-background-gold' style={{float: 'right'}} />
                                    <Button label="VOLTAR"  className='app-background-gold' style={{float: 'right', marginRight: '10px'}} onClick={() => this.setState({step: 2})}/>
                                </div>
                            </form>
                        }
                    </div> 
                    

                        
                        
                        
                    
                    
                    
                </div>
          </div>
      );
      
    }

}
export default PreCadastro;
